<template>
  <div class="sidebar-container">
    <van-sidebar class="sidebar-con" :active-key="-1">
      <SidebarItem
        ref="sidebarItem"
        v-for="(item, index) in menuData"
        :key="item.id"
        :menu="item"
        :level="0"
        :active-id="currentActiveId"
        @toggleChildren="toggleChildren"
      />
    </van-sidebar>
  </div>
</template>

<script>
import SidebarItem from "./SidebarItem.vue";

export default {
  name: "SidebarTree",
  components: {
    SidebarItem,
  },
  props: {
    menuData: {
      type: Array,
      default: () => {
        return [];
      },
    },
    activeId: {
      type: [String, Number],
      default: null,
    },
  },
  data() {
    return {
      // 内部存储当前激活的ID，避免直接修改props
      currentActiveId: this.activeId,
    };
  },
  watch: {
    // 监听props变化，同步到内部状态
    activeId: {
      handler(newVal) {
        this.currentActiveId = newVal;
      },
      immediate: true,
    },
  },
  methods: {
    toggleChildren(value) {
      // 更新内部激活状态
      this.currentActiveId = value;
      this.$emit("toggleChildren", value);
    },
    // 添加方法供父组件调用
    setActiveId(id) {
      this.currentActiveId = id;
    },
  },
};
</script>

<style lang="less" scoped>
@main-color: #4c9673;
@bg-color: #f7f8fa;
@active-bg-color: #eafbea;

.sidebar-container {
  width: 250px;
  height: 100%;
  overflow-y: auto;
  background-color: @bg-color;
  .sidebar-con {
    background-color: #a9cbc2;
  }
  .van-sidebar {
    --van-sidebar-item-text-color: #333;
    /* 移除默认的激活样式，完全使用我们自定义的样式 */
  }

  .slide-fade-enter-active,
  .slide-fade-leave-active {
    transition: all 0.3s ease;
  }
  .slide-fade-enter,
  .slide-fade-leave-to {
    transform: translateY(20px);
    opacity: 0;
  }
}
</style>
